import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function RegistryCard({ item, index = 0 }) {
  return (
    <motion.a
      href={item.href}
      target="_blank"
      rel="noreferrer"
      data-testid={`registry-card-${item.slug}`}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.8, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -3 }}
      className="group block rounded-sm border border-[#e6e4e0] bg-[#f9f8f6] hover:bg-[#f2efea] transition-colors duration-300 p-6 sm:p-7"
    >
      <div className="flex items-start justify-between mb-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#828c7e]">
          {item.category}
        </p>
        <ArrowUpRight className="h-4 w-4 text-[#6b6a68] transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>

      <h3 className="font-serif text-3xl sm:text-4xl leading-tight tracking-tight text-[#1c1b1a] font-normal">
        {item.name}
      </h3>
      <p className="mt-2 font-mono text-[11px] tracking-tight text-[#6b6a68]">
        by <span className="text-[#1c1b1a]">{item.creator}</span>
      </p>

      <p className="mt-6 font-sans text-[15px] leading-relaxed text-[#1c1b1a]/85">
        {item.tagline}
      </p>

      <div className="mt-8 flex flex-wrap gap-2">
        {item.tags.map((tag) => (
          <span
            key={tag}
            className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#6b6a68] border border-[#e6e4e0] rounded-full px-2.5 py-1"
          >
            {tag}
          </span>
        ))}
      </div>
    </motion.a>
  );
}
